import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "t-table-data" }
const _hoisted_2 = ["data-qe-id"]
const _hoisted_3 = {
  key: 0,
  class: "t-table-data-sort-icon"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icf-arrowTop" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icf-arrowBottom" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { computed } from 'vue'
import { SortOrder } from '@/model/ranking/Sorting'

const EVENT_TOGGLE_SORTING = 'toggle-sorting'

export default /*#__PURE__*/_defineComponent({
  __name: 'CTableHeadColumn',
  props: {
    sortFilter: {},
    isSelected: { type: Boolean, default: false },
    sortOrder: {},
    qeId: {}
  },
  emits: ['toggle-sorting'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const styleMap: { [key: string]: string } = {
  [SortOrder.ASCENDING]: 't-table-data-sort-up',
  [SortOrder.DESCENDING]: 't-table-data-sort-down',
}
const filterStyle = computed((): string => {
  return props.isSelected ? styleMap[props.sortOrder] : ''
})

function toggleSortOrder() {
  if (props.sortFilter) {
    const sortOrder = props.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING
    emit(EVENT_TOGGLE_SORTING, { filter: props.sortFilter, order: sortOrder })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", {
        class: _normalizeClass(['t-table-data-sort', filterStyle.value]),
        onClick: toggleSortOrder,
        "data-qe-id": _ctx.qeId
      }, [
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.sortFilter)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "icon")
      ])
    ])
  ]))
}
}

})